// DialogTrail Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class DialogTeamBlocked extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active || false
    }
  }

  static get propTypes () {
    return {
      active: PropTypes.bool,
      onClickContact: PropTypes.func,
      onClose: PropTypes.func,
      onShowError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      active: false,
      onClickContact: null,
      onClose: null,
      onShowError: null
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false
    })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  showError (msgIdent) {
    if (this.props.onShowError) {
      this.props.onShowError(msgIdent)
    }
  }

  render () {
    return (
      <Dialog className='dialog-block' active={this.state.active} modal={false}>
        <div className='dialog-blockcont' style={this.state.contHgt}>
          <div className='header'>
            <img
              src='/images/common/signup_logo.png'
              alt='Rodeo'
              className='inline-image'
            />
          </div>
          <div className='blockcont'>
            <div className='typo'>
              <h1 className='title'>
                <IntlMessage ident='common.list.blockMsg' />
              </h1>
            </div>
            <Button
              className='contactbtn'
              onClick={this._onClickContact.bind(this)}
              title='common.list.contactBtn'
            />
          </div>
        </div>
      </Dialog>
    )
  }

  _onClickContact () {
    if (this.props.onClickContact) {
      this.props.onClickContact()
    }
  }
}

export default DialogTeamBlocked
